export const partners = {
  aldar: {
    id: 'aldar',
    name: 'AlDar Exchange',
    code: 'ALDAR-001',
    legalName: 'AlDar Exchange LLC',
    country: 'UAE',
    primaryCurrency: 'AED',
    contractStart: '2024-06-01',
    status: 'active',
    accountManager: 'Faiyaz Syed',
    tier: 'enterprise',
    branches: [
      { code: 'DXB-001', name: 'Dubai Main', city: 'Dubai', agents: 8 },
      { code: 'AUH-001', name: 'Abu Dhabi', city: 'Abu Dhabi', agents: 5 },
      { code: 'SHJ-001', name: 'Sharjah', city: 'Sharjah', agents: 3 },
    ],
  },
  snoonu: {
    id: 'snoonu',
    name: 'Snoonu',
    code: 'SNOONU-001',
    legalName: 'Snoonu Technology WLL',
    country: 'Qatar',
    primaryCurrency: 'QAR',
    contractStart: '2024-09-15',
    status: 'active',
    accountManager: 'Faiyaz Syed',
    tier: 'growth',
    branches: [
      { code: 'DOH-001', name: 'Doha HQ', city: 'Doha', agents: 6 },
      { code: 'RUH-001', name: 'Riyadh Office', city: 'Riyadh', agents: 4 },
      { code: 'KWI-001', name: 'Kuwait Office', city: 'Kuwait City', agents: 2 },
    ],
  },
};

export default partners;
